import PropTypes from 'prop-types';
import React__default, { useMemo } from 'react';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { ColorSwatchLabelPositions, ColorSwatchesContext } from './color-swatches.context.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * @deprecated
  * use size instead
  */
  sizeVariant: deprecatedProp(PropTypes.oneOf(['standard', 'super']), DEPRECATED_PROP_MESSAGES.size),

  /**
  * The size of the color swatches
  */
  size: PropTypes.oneOf(['standard', 'super']),

  /**
  * Where to position the label tooltips relative to its swatch
  */
  labelPosition: PropTypes.oneOf(ColorSwatchLabelPositions)
};
var ColorSwatches = createComponent({
  displayName: 'ColorSwatches',
  root: 'div',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-color-swatches']);
      var _props$sizeVariant = props.sizeVariant,
          sizeVariant = _props$sizeVariant === void 0 ? 'standard' : _props$sizeVariant,
          _props$size = props.size,
          size = _props$size === void 0 ? sizeVariant : _props$size;
      if (size != 'standard') classNameSet.add("swan-color-swatches-".concat(size));
      return classNameSet;
    },
    wrapRoot: function wrapRoot(_ref, _derivedProps, element) {
      var labelPosition = _ref.labelPosition;
      var ctxValue = useMemo(function () {
        return {
          labelPosition: labelPosition
        };
      }, [labelPosition]);
      return /*#__PURE__*/React__default.createElement(ColorSwatchesContext.Provider, {
        value: ctxValue
      }, element);
    }
  }
});
ColorSwatches.defaultProps = {
  labelPosition: 'top',
  size: 'standard'
};
export { ColorSwatches };